import Vue from 'vue'
import App from './App.vue'
import WindowProps from './plugins/WindowProps'

Vue.config.productionTip = false
Vue.use(WindowProps)

new Vue({
  render: h => h(App),
}).$mount('#app')
